module.exports = __webpack_public_path__ + "img/5.4.NH3-N.de17a929.png";